import * as React from 'react';
import styled from 'styled-components';

import { Container } from './Container';
import { HeaderBottomCard } from './HeaderBottomCard';

//GrapQL
import { getAdminClient } from '../layout/admin/AdminApolloClient';
import { useQuery } from '@apollo/client';
import { FP_OFFICES } from '../../../client/__graphql__/queries/frontpage/getOffices';

const client = getAdminClient();

export const HeaderBottomStyle = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  justify-content: space-evenly;
  flex-flow: row wrap;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.burgundy};
  padding: 10px;
  position: relative;

  @media all and (max-width: 1000px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media all and (max-width: 900px) {
    grid-template-columns: 1fr 1fr;
  }
  @media all and (max-width: 630px) {
    grid-template-columns: 1fr;
  }

  @media all and (max-width: 600px) {
    grid-template-columns: 1fr;
    transform: none;
  }
`;

export const HeaderBottom = React.forwardRef((props, ref: any) => {
  const [items, SetItems] = React.useState<any>(null);

  const { data, loading } = useQuery(FP_OFFICES, {
    variables: null,
    fetchPolicy: 'network-only',
    client: client,
  });

  React.useEffect(() => {
    if (data?.getFrontpageOffices?.length > 0) {
      const array: Array<any> = [];
      let index = 0;
      data.getFrontpageOffices.map((item: any) => {
        array.push({
          key: `office-` + index,
          title: item.title,
          text: item.description,
          link: '/kontor/' + item.urltag,
        });
        index++;
      });
      SetItems(array);
    }
  }, [data]);

  return (
    <Container ref={ref} className="top">
      {items && items?.length > 0 ? (
        <HeaderBottomStyle>
          {items.map((item: any) => (
            <HeaderBottomCard
              key={item.key}
              title={item.title}
              text={item.text}
              link={item.link}
            />
          ))}
        </HeaderBottomStyle>
      ) : null}
    </Container>
  );
});
